import { US } from "constants/countryCodes";
import { useGetCountriesDataQuery } from "store/apis/onboarding";
import { QuestionOption } from "v2/constants/taxSetupQuestions";

const EMPTY_OPTIONS: QuestionOption[] = [];

export const useUsStateOptions = (
  excludeStateId?: string
): QuestionOption[] => {
  const { data: countries } = useGetCountriesDataQuery();

  const usStates = countries?.find(
    (country) => country.code_alpha_2 === US
  )?.states;

  if (!usStates) return EMPTY_OPTIONS;

  return usStates
    .filter((state) => state.uuid !== excludeStateId)
    .map((state) => ({ label: state.name, value: state.uuid }));
};
